import Nullstack from 'nullstack';
export default function IconCalculator({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-calculator",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "3",
    width: "16",
    height: "18",
    rx: "2"
  }), "   ", Nullstack.element("rect", {
    x: "8",
    y: "7",
    width: "8",
    height: "3",
    rx: "1"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "14",
    x2: "8",
    y2: "14.01"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "14",
    x2: "12",
    y2: "14.01"
  }), "   ", Nullstack.element("line", {
    x1: "16",
    y1: "14",
    x2: "16",
    y2: "14.01"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "17",
    x2: "8",
    y2: "17.01"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "17",
    x2: "12",
    y2: "17.01"
  }), "   ", Nullstack.element("line", {
    x1: "16",
    y1: "17",
    x2: "16",
    y2: "17.01"
  }), " ");
}